var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 200,
    viewBox: "0 0 149 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.125 200V144.186L73.5688 125.581L64.2563 166.512L0 153.488L3.725 134.884L48.425 144.186L63.325 68.8372L46.5625 75.3488V106.977H27.9375V63.2558L64.7219 47.4419C70.1542 45.1163 74.1508 43.6047 76.7117 42.907C79.2727 42.2093 81.6396 41.8605 83.8125 41.8605C87.0719 41.8605 90.0984 42.7132 92.8922 44.4186C95.6859 46.124 97.9365 48.3721 99.6437 51.1628L108.956 66.0465C112.992 72.5581 118.463 77.907 125.37 82.093C132.276 86.2791 140.153 88.3721 149 88.3721V106.977C138.756 106.977 129.172 104.845 120.248 100.581C111.323 96.3178 103.834 90.6977 97.7812 83.7209L92.1938 111.628L111.75 130.233V200H93.125ZM97.7812 37.2093C92.6594 37.2093 88.2747 35.3876 84.6273 31.7442C80.98 28.1008 79.1562 23.7209 79.1562 18.6047C79.1562 13.4884 80.98 9.10853 84.6273 5.46512C88.2747 1.82171 92.6594 0 97.7812 0C102.903 0 107.288 1.82171 110.935 5.46512C114.583 9.10853 116.406 13.4884 116.406 18.6047C116.406 23.7209 114.583 28.1008 110.935 31.7442C107.288 35.3876 102.903 37.2093 97.7812 37.2093Z",
    fill: "#169c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.06457154f6db4159d74d1fe21f4ecdfb.svg";
export { ForwardRef as ReactComponent };